import { Popover } from "@mui/material";
import { GridApi } from "ag-grid-community";
import _ from 'lodash';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { loadPrivateAutomationRules, } from "../../actions";
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { AddRuleIcon } from "../../icon";
import { RuleModel, RuleStatus, RuleType } from "../../models/auto-alert.model";
import * as selector from '../../selectors/selectors';
import { UtilityService } from "../../services/UtilityService";
import { AppRoutes } from "../routes/route.path";
import { AutomationRulesLabel, buttonLabels, pageTitles } from "../shared/constants";
import FilterComponent from "../shared/filters/filter.component";
import { CustomFilterCategory } from "../shared/filters/filter.model";
import PageHeaderComponent from "../shared/page-header.component";
import AddRuleComponent from "./add-rule.component";
import PrivateRulesComponent from "./private-rules-component";
import { Link, useLocation } from "react-router-dom";
import LogsComponent from "./logs.component";

interface Props {
}

const RulesComponent = (props: Props) => {
	const dispatch = useDispatch()
	const location = useLocation()
	const PrivateRules: RuleModel[] = useSelector(selector.privateRules)
	const GlobalRules: RuleModel[] = useSelector(selector.globalRules)
	const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)

	const [SearchInput, SetSearchInput] = useState<string>("");
	const [editoption, SetEditoption] = useState(false);
	const [anchorEl, SetAnchorEl] = useState(null);
	const [OperatingRule, SetOperatingRule] = useState<RuleModel>();
	const [ShowFilterOptions, SetShowFilterOptions] = useState(false);
	const [editStartOption, SetEditStartOption] = useState(false);
	const [editOption, SetEditOption] = useState(false);
	const [gridApi, setGridApi] = useState<GridApi>(null);
	const [columnApi, setColumnApi] = useState<any>(null);
	const [filterOptions, setFilterOptions] = useState<CustomFilterCategory[]>([]);
	const [selectedFilterTypes, setSelectedFilterTypes] = useState<string[]>([]);
	const [isAutoReply, setIsAutoReply] = useState<boolean>(true)

	//filters
	const initialFilterOptions = () => {
		const filterData: any[] = [
			{
				Id: 2,
				Title: "Status",
				IsSelectedAll: false,
				Options: _(PrivateRules.filter(x => x.Type === (isAutoReply ? RuleType.AUTO_REPLY : RuleType.KEYWORD)))
					.map(row => ({
						Key: "Status",
						Id: row.ID,
						Label: row.Status === RuleStatus.ACTIVE ? AutomationRulesLabel.ACTIVE : row.Status === RuleStatus.COMPLETED ? AutomationRulesLabel.COMPLETED : AutomationRulesLabel.INACTIVE,
						Value: row.Status,
						IsSelected: false
					}))
					.uniqBy('Label')
					.value()
			},

		]
		setFilterOptions(filterData)
	}

	const handleApplyFilters = (filters: CustomFilterCategory[]) => {
		setFilterOptions(filters);
		const { result } = UtilityService.getFilterTypes(filters);
		setSelectedFilterTypes(result)
	};

	useEffect(() => {
		initialFilterOptions()
	}, [PrivateRules, isAutoReply])

	const handleClickFilter = (event: React.MouseEvent<HTMLButtonElement>) => {
		SetAnchorEl(event.currentTarget);
	};
	const handleCloseFilter = () => {
		SetAnchorEl(null);
		SetShowFilterOptions(false);
	};
	const openAddRule = (rowId: string, obj?: RuleModel) => {
		SetEditoption(true);
		SetOperatingRule(obj);
	};

	const closeAddRule = (isConfim: boolean) => {
		SetEditoption(false);
		SetOperatingRule(undefined);
		resetFilters()
	};

	const editStartHandler = (value: any) => {
		SetEditStartOption(value);
	};
	const editOptionHandler = (value) => {
		SetEditOption(value);
	};

	const onGridReady = (params) => {
		setGridApi(params.api)
		setColumnApi(params.columnApi)
	}

	const getGridTitle = () => {
		if (location.pathname === AppRoutes.AUTOMATION_RULES) {
			return PrivateRules.length === 1 ? "1 Automation Rule" : PrivateRules.length + "  " + pageTitles.AUTOMATION_RULES;
		} else {
			return GlobalRules.length === 1 ? "1 Automation Rule" : GlobalRules.length + "  " + pageTitles.AUTOMATION_RULES;
		}
	}

	useEffect(() => {
		setRefreshHandler(refreshData);
		if (SearchInput !== "") {
			gridApi.setQuickFilter(SearchInput);
		}
	}, [gridApi, columnApi])

	const globalSearch = (event: any) => {
		SetSearchInput(event.target.value);
		gridApi.setQuickFilter(event.target.value);
	};

	const refreshData = () => {
		resetFilters()
		loadPrivateAutomationRules(dispatch)
		if (!!columnApi) {
			columnApi.resetColumnState();
		}
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	};

	const resetFilters = () => {
		setFilterOptions([])
		setSelectedFilterTypes([])
		initialFilterOptions()
		if (!!columnApi) {
			columnApi.resetColumnState();
		}
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	}

	const runLoader = () => {
		if (!!gridApi) {
			gridApi.refreshCells({ force: true })
		}
	}

	useEffect(() => {
		SetSearchInput("")
		if (location.pathname?.replace("/*", "") === AppRoutes.AUTOMATION_RULES) {
			setIsAutoReply(true)
			setHeaderTitle(pageTitles.AUTOMATION_RULES)
			setHeaderCount(PrivateRules.filter(x => x.Type === (isAutoReply ? RuleType.AUTO_REPLY : RuleType.KEYWORD))?.length || 0)
		}
		else {
			setIsAutoReply(false)
		}
	}, [location.pathname])

	useEffect(() => {
		refreshData()
	}, [])

	return IsMobileDevice && editoption ? (
		<AddRuleComponent
			OnClose={closeAddRule}
			Show={editoption}
			Rule={OperatingRule}
			ButtonLabel={buttonLabels.SAVE}
			HandleSubmitSuccess={() => refreshData()}
		/>
	) : (
		<>
			<div className='d-flex flex-direction h-p-100'>
				<PageHeaderComponent
					Actions={location.pathname !== AppRoutes.AUTOMATION_LOGS && [
						{
							OnClick: () => openAddRule("", undefined),
							ButtonLabel: buttonLabels.ADD_RULE,
							Icon: AddRuleIcon,
							Variant: "primary-btn-small",
						},
					]}
					HandleFilter={handleClickFilter}
					ShowFilterIcon={location.pathname !== AppRoutes.AUTOMATION_LOGS}
					IsFilterApplied={filterOptions.flatMap(x => x.Options.filter(x => x.IsSelected)).length}
					onSearch={globalSearch}
					GridTitle={""}
					PlaceHolder={"Find..."}
				/>
				<div className="d-flex">
					<Link className={`${!IsMobileDevice ? "ml-2 w-18" : " w-20"}  t-align-center py-1 c-pointer h4-regular ${location.pathname === AppRoutes.TRANSFERS ? 'color-conv-hist-menu  h4-semibold' : 'color-conv-section-inactive'}`} to={AppRoutes.AUTOMATION_RULES} >{pageTitles.AUTO_REPLIES}</Link>
					<Link className={`${!IsMobileDevice ? "w-20" : "w-20"}  t-align-center py-1 c-pointer h4-regular ${location.pathname === AppRoutes.AUTOMATION_KEYWORD ? 'color-conv-hist-menu h4-semibold' : 'color-conv-section-inactive'}`} to={AppRoutes.AUTOMATION_KEYWORD}>{pageTitles.KEYWORD_REPLIES}</Link>
					<Link className={`${!IsMobileDevice ? "w-10" : "w-8 mr-1"}  t-align-center py-1 c-pointer h4-regular ${location.pathname === AppRoutes.AUTOMATION_LOGS ? 'color-conv-hist-menu h4-semibold' : 'color-conv-section-inactive'}`} to={AppRoutes.AUTOMATION_LOGS}>{pageTitles.LOGS}</Link>
				</div>
				{
					<div className={`show-conversation-animation show-conversation-border show-conversation-height bg-color-primary-light ${location.pathname?.replace("/*", "") === AppRoutes.AUTOMATION_RULES ? `${IsMobileDevice ? "w-14 ml-2" : "ml-2 w-18"}` :
						location.pathname?.replace("/*", "") === AppRoutes.AUTOMATION_KEYWORD ? `${IsMobileDevice ? "ml-18 w-20" : "ml-20 w-20"}` : `${IsMobileDevice ? "ml-35" : "ml-40 w-10"}`}`}>
					</div>
				}
				{location.pathname?.replace("/*", "") === AppRoutes.AUTOMATION_LOGS ?
					<LogsComponent
						OnGridReady={onGridReady}
						GridApi={gridApi}
					/> :
					<PrivateRulesComponent
						SearchInput={SearchInput}
						filterOptions={filterOptions}
						editOption={editOption}
						editOptionHandler={editOptionHandler}
						editStartOption={editStartOption}
						editStartHandler={editStartHandler}
						onGridReady={onGridReady}
						runLoader={runLoader}
						selectedFilterTypes={selectedFilterTypes}
						gridApi={gridApi}
						resetFilters={resetFilters}
						IsAutoReply={isAutoReply}
					/>
				}
			</div>
			{Boolean(anchorEl) &&
				<Popover
					open={Boolean(anchorEl)}
					anchorEl={anchorEl}
					onClose={handleCloseFilter}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
					classes={{ paper: `min-w-40 ${ShowFilterOptions ? "min-h-40" : ""}` }}
				>
					<FilterComponent
						Filters={filterOptions}
						HandleApplyFilters={handleApplyFilters}
						OnClose={handleCloseFilter}
					/>
				</Popover>
			}
			{editoption && (
				<AddRuleComponent
					OnClose={closeAddRule}
					Show={editoption}
					Rule={OperatingRule}
					ButtonLabel={buttonLabels.SAVE}
					HandleSubmitSuccess={() => refreshData()}
					IsAutoReply={isAutoReply}
				/>
			)}
		</>
	);
}

export default RulesComponent;
